export default {"src":"https://images-cdn.curipod.com/d-3562c6ac/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};